import { React } from "react";
import { useSelector } from "react-redux";

import { AttachmentView } from "../../../common/attachments/attachmentview";
import { actionTypeSelector, contractSelector } from "../../../reducers";


export function ContractGroup5({ state }) {
  const actionType = useSelector(actionTypeSelector);
  const contract = useSelector(contractSelector);

  return <AttachmentView
    section="contract"
    entityid={state.contractId}
    attachments={state.attachments}
    savedId={ (actionType === "POST_CONTRACT_SUCCEEDED" || actionType === "POST_CONTRACT_EDIT_SUCCEEDED") && contract.contractId }
  />;
}
